import React, { useContext, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { LocalesContext } from "../../contexts/LocalesContext";
import { MqttContext } from '../../contexts/MqttContext';
import ConfResumeComponent from "../components/ConfResumeComponent";
import InputTextComponent from "../../components/InputTextComponent";
import ButtonComponent from "../../components/ButtonComponent";
import { flashDanger } from "../../utils/flash";
import { postRequest } from "../../utils/requests";
import { uuidv4 } from "../../utils/data";
import { getMachineParamsValue, unitaMisuraIntToString } from '../../utils/irriapp'

export default function PresetsConfirmScreen(props) {
  const isEdit = props.preset && props.preset.uuid;
  const [name, setName] = useState(props.preset.name || "");
  const { machineParams } = useContext(MqttContext);
  const { t } = useContext(LocalesContext);

  const onConfirm = () => {
    if (!name) {
      flashDanger(t("application.messages.name_not_compiled"));
      return;
    }

    if (isEdit) {
      postRequest(
        props.apis.presets_manage_actions_action,
        {
          actions: [
            {
              apis_auth_token: props.apis.auth_token,
              uuid: props.preset.uuid,
              type: "update",
              timestamp: new Date(),
              data: { name, params: props.preset.params },
            },
          ],
        },
        (response) => {
          if (response.result) {
            props.goTo("presets");
          }
        }
      );
    } else {
      postRequest(
        props.apis.presets_create_action,
        {
          apis_auth_token: props.apis.auth_token,
          uuid: uuidv4(),
          name,
          machine_uuid: props.machine_uuid,
          timestamp_creation: new Date(),
          params: props.preset.params,
        },
        (response) => {
          if (response.result) {
            props.goTo("presets");
          }
        }
      );
    }
  };

  const onRemove = () => {
    postRequest(
      props.apis.presets_manage_actions_action,
      {
        apis_auth_token: props.apis.auth_token,
        actions: [{ uuid: props.preset.uuid, type: "remove" }],
      },
      (response) => {
        if (response.result) {
          props.goTo("presets");
        }
      }
    );
  };

  const onGoBack = () => {
    props.goBack({
      type: props.type,
      params: props.preset.params,
      preset: props.preset,
    });
  };

  return (
    <div className="c-form">
      <div className="c-container">
        <div className="c-form__body">
          <button className="c-form__close" onClick={onGoBack}>
            <i className="fas fa-times"></i>
          </button>
          
          <div className="c-form__header">
            <div className="c-input__title">{t("application.titles.presets_confirm")}</div>
          </div>

          <div>
            <div className="c-input">
              <div className="c-input__label">{t("application.titles.configuration_resume")}</div>
            </div>
            <ConfResumeComponent configuration={props.preset.params} converterType={unitaMisuraIntToString(getMachineParamsValue(machineParams, "conf_unita_misura"))} />

            <div className="c-form__mb"></div>
            <InputTextComponent
              label={t("application.titles.presets_name")}
              value={name}
              onChange={(v) => setName(v)}
            />
          </div>

          <div className="c-form__actions">
            <div className="col-5">
              <div className="row row--buttons">
                <ButtonComponent
                  className="c-button c-button--cenere"
                  label={t("application.cta.cancel")}
                  confirm={t("application.messages.confirm_cancel")}
                  onClick={() => props.goTo("presets")}
                  warning
                />
                <ButtonComponent
                  className="c-button"
                  label={t("application.cta.confirm")}
                  onClick={onConfirm}
                />
                {isEdit && (
                  <ButtonComponent
                    className="c-button c-button--orange"
                    label={t("application.cta.remove")}
                    confirm={t("application.messages.confirm_remove")}
                    onClick={onRemove}
                    danger
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

PresetsConfirmScreen.propTypes = {
  goBack: PropTypes.func,
  goTo: PropTypes.func,
  machine_uuid: PropTypes.string.isRequired,
  apis: PropTypes.shape({
    auth_token: PropTypes.string.isRequired,
    presets_manage_actions_action: PropTypes.string.isRequired,
    presets_create_action: PropTypes.string.isRequired,
  }).isRequired,
};

PresetsConfirmScreen.defaultProps = {
  goBack: () => {},
  goTo: () => {},
};